import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";
import { FONTS } from "@/components/SlideView";

const sel = "h-9 w-full rounded-md border bg-white px-2 text-sm";
const GRID = [[0, 8], [50, 8], [100, 8], [0, 50], [50, 50], [100, 50], [0, 92], [50, 92], [100, 92]];
const ALIGN = ["left", "center", "right"];

const Color = ({ label, value, onChange, testid }) => (
  <div><Label className="text-xs">{label}</Label>
    <div className="flex items-center gap-2 h-9 rounded-md border px-2">
      <input type="color" value={value} onChange={(e) => onChange(e.target.value)} className="w-7 h-7 border-0 bg-transparent cursor-pointer" data-testid={testid} />
      <span className="font-mono text-xs">{value}</span></div></div>);
const Range = ({ label, value, onChange, min = 0, max = 100, testid }) => (
  <div><Label className="text-xs">{label}: {value}%</Label>
    <Slider value={[Number(value)]} min={min} max={max} step={1} onValueChange={([v]) => onChange(v)} className="mt-3" data-testid={testid} /></div>);

export function SlideDesign({ d, set, i }) {
  const f = (k, v) => set({ ...d, [k]: v });
  return (
    <div className="space-y-4" data-testid={`slide-design-${i}`}>
      <div className="grid sm:grid-cols-3 gap-3">
        <div><Label className="text-xs">Background</Label>
          <select value={d.bg_type} onChange={(e) => f("bg_type", e.target.value)} className={sel} data-testid={`slide-bg-type-${i}`}>
            <option value="image">Picture</option><option value="color">Solid colour</option><option value="gradient">Gradient</option></select></div>
        <Color label={d.bg_type === "gradient" ? "Colour 1" : "Background colour"} value={d.bg_color} onChange={(v) => f("bg_color", v)} testid={`slide-bg-color-${i}`} />
        {d.bg_type === "gradient" ? <Color label="Colour 2" value={d.bg_color2} onChange={(v) => f("bg_color2", v)} testid={`slide-bg-color2-${i}`} />
          : d.bg_type === "image" && <div><Label className="text-xs">Picture fit</Label>
            <select value={d.image_fit} onChange={(e) => f("image_fit", e.target.value)} className={sel} data-testid={`slide-fit-${i}`}>
              <option value="cover">Fill (may crop edges)</option><option value="contain">Show whole picture</option></select></div>}
      </div>
      <label className="flex items-center gap-2 text-sm font-semibold"><Switch checked={d.show_text} onCheckedChange={(v) => f("show_text", v)} data-testid={`slide-show-text-${i}`} />
        Show text over this slide <span className="font-normal text-xs text-muted-foreground">(turn off for ready-made picture slides — the button link then makes the whole slide clickable)</span></label>
      {d.show_text && (<>
        <div className="grid sm:grid-cols-4 gap-3">
          <div><Label className="text-xs">Font</Label>
            <select value={d.font} onChange={(e) => f("font", e.target.value)} className={sel} data-testid={`slide-font-${i}`}>
              {FONTS.map((x) => <option key={x} value={x}>{x === "default" ? "Site default" : x}</option>)}</select></div>
          <div><Label className="text-xs">Heading size</Label>
            <select value={d.size} onChange={(e) => f("size", e.target.value)} className={sel} data-testid={`slide-size-${i}`}>
              <option value="sm">Small</option><option value="md">Medium</option><option value="lg">Large</option><option value="xl">Extra large</option></select></div>
          <Color label="Text colour" value={d.text_color} onChange={(v) => f("text_color", v)} testid={`slide-text-color-${i}`} />
          <Color label="Accent (top line, button)" value={d.accent_color} onChange={(v) => f("accent_color", v)} testid={`slide-accent-color-${i}`} />
        </div>
        <div className="grid sm:grid-cols-[auto_1fr] gap-5 items-start">
          <div><Label className="text-xs">Quick position</Label>
            <div className="grid grid-cols-3 gap-1 mt-1 w-24" data-testid={`slide-pos-grid-${i}`}>
              {GRID.map(([x, y], k) => (
                <button key={k} type="button" onClick={() => set({ ...d, x, y, align: ALIGN[k % 3] })} data-testid={`slide-pos-${i}-${k}`}
                  className={`h-7 rounded border ${d.x === x && d.y === y ? "bg-steel border-steel" : "bg-slate-100 hover:bg-slate-200"}`} />))}
            </div></div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Range label="Across (left → right)" value={d.x} onChange={(v) => f("x", v)} testid={`slide-x-${i}`} />
            <Range label="Down (top → bottom)" value={d.y} onChange={(v) => f("y", v)} testid={`slide-y-${i}`} />
            <Range label="Text box width" value={d.max_width} min={30} onChange={(v) => f("max_width", v)} testid={`slide-width-${i}`} />
            <Range label="Darken picture behind text" value={d.overlay} max={95} onChange={(v) => f("overlay", v)} testid={`slide-overlay-${i}`} />
            <div className="sm:col-span-2"><Label className="text-xs">Text alignment</Label>
              <div className="inline-flex rounded-lg border p-1 ml-2">{ALIGN.map((a) => (
                <button key={a} type="button" onClick={() => f("align", a)} data-testid={`slide-align-${a}-${i}`}
                  className={`px-3 py-1 text-xs rounded-md capitalize ${d.align === a ? "bg-steel text-white" : ""}`}>{a}</button>))}</div></div>
          </div>
        </div>
      </>)}
    </div>
  );
}
